import Config from "src/Constants/Config";
import setCurrentPage from "src/Utils/setCurrentPage";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import store from "src/Reducers/store";
import FrameTV from "src/Component/FrameTV";
import PanelRight from "src/Component/PanelRight";

const PageId = 7;
const BackPageId = PageId - 1;
const NextPageId = PageId + 1;

const DATA = () => {
  const baseImageBG = `${Config.BASE_URL}/images/BG/`;
  const currentPage = useSelector(() => store.getState().appReducer.currentPage);

  const [step, setStep] = useState<number>(0);
  const baseImages = `${Config.BASE_URL}/images/screen_${PageId}/`;
  const rightSideImage_0 = `${baseImages}animation_0.jpg`;

  const rightSideComponentStyle: React.CSSProperties = {
    transition: "opacity .6s ease-in-out",
    height: "100%",
    width: "100%",
  };

  useEffect(() => {
    if (PageId === currentPage) setTimeout(() => setStep(1), 400);
    else setStep(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step, currentPage]);

  const title = "Maximize Revenue\nwith Smarter Ads";
  const description =
    "Unlock new revenue streams with the Infosys\nEntertainment Platform’s targeted advertising\nsolutions. Seamlessly integrate intelligent, non-\nintrusive ads that enhance user experience while\ndriving measurable results.\nDynamic ad placements ensure personalized\ncontent delivery, tailored to individual preferences.\n\nWith advanced user targeting, providers can\nachieve increased ad revenue without\ncompromising viewer satisfaction.\nLeverage the power of data-driven advertising to\ncreate impactful campaigns that benefit both users\nand advertisers.";

  return {
    bgImage: `${baseImageBG}BG_2.jpg`,
    title,
    description,
    rightSideComponent: (
      <PanelRight>
        <FrameTV scrollDisabled={true}>
          <img src={rightSideImage_0} alt="" style={{ ...rightSideComponentStyle, opacity: step >= 1 ? 1 : 0 }} />
        </FrameTV>
      </PanelRight>
    ),
    back: {
      label: "Back",
      type: "back",
      startIcon: { icon: "arrow-right", color: "#fff" },
      onClick: () => setCurrentPage(BackPageId),
      style: { gap: "var(--width-16)" },
    },
    next: {
      label: "Continue",
      type: "next",
      endIcon: { icon: "arrow-left" },
      onClick: () => setCurrentPage(NextPageId),
      style: { gap: "var(--width-16)" },
    },
  };
};

export default DATA;
